<ul class="instruction-steps">
	<li data-e2e-suppliers-upload-step-2-template-instructions-1>
		{{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoText1' | translate }}
	</li>
	<li>
		<span data-e2e-suppliers-upload-step-2-template-instructions-2>
			{{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoText2' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-suppliers-upload-step-2-template-instructions-3>
			{{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoText3' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-suppliers-upload-step-2-template-instructions-4>
			{{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoText4' | translate }}
		</span>
	</li>
	<li>
		<span data-e2e-suppliers-upload-step-2-template-instructions-5>
			{{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoText5' | translate }}
		</span>
	</li>

	<ul class="data-information">
		<li data-e2e-suppliers-upload-step-2-template-instructions-buyer-country-code>
			<strong
				>{{ 'SupplierRecordsColumnBuyerCountryCodeCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoBuyerCountryCode' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-buyer-vat-number>
			<strong
				>{{ 'SupplierRecordsColumnBuyerVatNumberCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoBuyerVatNumber' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-buyer-username>
			<strong>{{ 'SupplierRecordsColumnBuyerManagerUsernameCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoBuyerManagerUsername' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-country-code>
			<strong
				>{{ 'SupplierRecordsColumnSupplierCountryCodeCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierCountryCode' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-vat-number>
			<strong
				>{{ 'SupplierRecordsColumnSupplierVatNumberCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierVatNumber' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-name>
			<strong
				>{{ 'SupplierRecordsColumnSupplierNameCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierName' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-address>
			<strong
				>{{ 'SupplierRecordsColumnSupplierAddressLine1Code' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker'
				| translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>, <strong>{{ 'SupplierRecordsColumnSupplierAddressLine2Code' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>,
			<strong>{{ 'SupplierRecordsColumnSupplierAddressLine3Code' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>,
			<strong
				>{{ 'SupplierRecordsColumnSupplierZipCodeCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>,
			<strong
				>{{ 'SupplierRecordsColumnSupplierCityCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierAddressLine' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-phone-number>
			<strong
				>{{ 'SupplierRecordsColumnSupplierPhoneNumberCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierPhoneNumber' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-language>
			<strong>{{ 'SupplierRecordsColumnSupplierLanguageCodeCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierLanguageCode' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-username>
			<strong>{{ 'SupplierRecordsColumnSupplierUserNameCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierUserName' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-email>
			<strong
				>{{ 'SupplierRecordsColumnSupplierUserEmailCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierUserEmail' | translate }}</span>
		</li>
		<li data-e2e-suppliers-upload-step-2-template-instructions-contract-number>
			<strong>{{ 'SupplierRecordsColumnContractNumberCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong> -
			<span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoContractNumber' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-iban>
			<strong
				>{{ 'SupplierRecordsColumnSupplierIbanCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierIban' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-swift>
			<strong
				>{{ 'SupplierRecordsColumnSupplierSwiftCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{ 'MandatoryColumnMarker' |
				translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierSwift' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-bank-country-code>
			<strong
				>{{ 'SupplierRecordsColumnSupplierBankCountryCodeCode' | translate: 'SupplierRecordsUploadExcelTemplate' }} {{
				'MandatoryColumnMarker' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong
			>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierBankCountryCode' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-bank-name>
			<strong>{{ 'SupplierRecordsColumnSupplierBankNameCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierBankName' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-supplier-bank-address>
			<strong>{{ 'SupplierRecordsColumnSupplierBankAddressCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoSupplierBankAddress' | translate }}</span>
		</li>

		<li data-e2e-suppliers-upload-step-2-template-instructions-automatic-payments>
			<strong>{{ 'SupplierRecordsColumnActivePaymentRequestCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>
			- <span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoActivePaymentRequest' | translate }}</span>
		</li>

		@if (showActiveAutomaticFundingRequestInfo) {
		<li data-e2e-suppliers-upload-step-2-template-instructions-automatic-fundings>
			<strong>{{ 'SupplierRecordsColumnActiveAutomaticFundingRequestCode' | translate: 'SupplierRecordsUploadExcelTemplate' }}</strong>
			-
			<span> {{ 'supplier-upload-step1.SupplierTemplateInstructionsInfoActiveAutomaticFundingRequest' | translate }}</span>
		</li>
		}
	</ul>
</ul>
